export default {"src":"/_next/static/media/darkChevron.a9007cbf.svg","height":14,"width":8,"blurWidth":0,"blurHeight":0};